import { LoadingState } from '@core';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ProjectsActions } from './projects.actions';
import { initialProjectState } from './projects.state';

export const projectsFeature = createFeature({
  name: 'projects',
  reducer: createReducer(
    initialProjectState,
    on(ProjectsActions.projectLoaded, (state, action) => ({
      ...state,
      project: action.project,
      requestState: LoadingState.LOADED,
    })),
    on(ProjectsActions.projectsLoaded, (state, action) => ({
      ...state,
      projectList: action.projects,
      requestState: LoadingState.LOADED,
    })),
    on(ProjectsActions.loadProjectFailed, (state, action) => ({
      ...state,
      project: null,
      requestState: action,
    })),
    on(ProjectsActions.loadProjectsFailed, (state, action) => ({
      ...state,
      projectList: [],
      requestState: action,
    })),
    on(ProjectsActions.loadProjects, state => ({
      ...state,
      projectList: [],
      requestState: LoadingState.LOADING,
    })),
    on(ProjectsActions.refreshProject, state => ({
      ...state,
      project: null,
      requestState: LoadingState.LOADING,
    })),
    on(ProjectsActions.setSelectedProject, (state, action) => ({
      ...state,
      selectedProjectId: action.projectId,
    })),
    on(ProjectsActions.projectDetailsPageOpened, state => ({
      ...state,
      project: null,
      requestState: LoadingState.LOADING,
    }))
  ),
});
